var map = {
	"./AUTHENTICATION.json": 514,
	"./HISTORIC.json": 27,
	"./PORTFOLIO.json": 950,
	"./RESERVATION.json": 676,
	"./SPOT AUTHENTICATION.json": 198,
	"./SPOT REALTIME.json": 359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 135;